export const requiredMessage = 'This field is required';
export const emailRegexp = new RegExp('^(?!\\.)[a-zA-Z0-9._%+-]+(?<!\\.)@[a-zA-Z0-9.-]+(?<!\\.)\\.[a-zA-Z]{2,}$');
